import * as types from 'constants/actionTypes'

export const receiveUser = (user) => ({ type: types.RECEIVE_USER, user })



// WEBPACK FOOTER //
// ./src/actions/userAC.js